import React from 'react';
import {
  FaSearch,
  FaUserTie,
  FaComments,
  FaClipboardCheck,
  FaStar,
  FaCheckCircle,
  FaArrowRight,
  FaBriefcase,
  FaUsers,
  FaHandshake,
  FaEye,
  FaExternalLinkAlt,
} from 'react-icons/fa';

const Zwacop = () => {
  const steps = [
    { icon: <FaSearch />, title: 'Recherche', text: 'Le client recherche un service ou un prestataire' },
    { icon: <FaUserTie />, title: 'Découverte', text: 'Il trouve un prestataire qualifié' },
    { icon: <FaComments />, title: 'Échange', text: 'Discussion et mise en relation directe' },
    { icon: <FaClipboardCheck />, title: 'Demande', text: 'Le service est demandé et planifié' },
    { icon: <FaStar />, title: 'Prestation', text: 'Le service est réalisé avec qualité' },
    { icon: <FaCheckCircle />, title: 'Évaluation', text: 'Le client évalue le prestataire' },
  ];

  const benefits = [
    { icon: <FaSearch />, text: 'Trouver rapidement un prestataire qualifié' },
    { icon: <FaBriefcase />, text: 'Créer de nouvelles opportunités professionnelles' },
    { icon: <FaHandshake />, text: 'Mettre en relation l\'offre et la demande' },
    { icon: <FaUsers />, text: 'Faciliter l\'accès aux services et aux compétences' },
    { icon: <FaEye />, text: 'Développer la visibilité des prestataires' },
  ];

  return (
    <section id="zwacop" className="zwacop section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Notre plateforme</span>
          <h2 className="section-title">ZWACOP — La plateforme qui connecte clients et prestataires</h2>
          <p className="section-subtitle">
            ZWACOP est une plateforme digitale qui met directement en relation les clients et les
            prestataires de services. Simple, efficace et pensée pour le marché africain, elle
            facilite l'accès aux services et crée des opportunités pour les professionnels.
          </p>
        </div>

        <div className="zwacop-flow">
          <div className="zwacop-flow-header">
            <span className="zwacop-flow-label">Comment ça fonctionne</span>
          </div>
          <div className="zwacop-steps">
            {steps.map((step, index) => (
              <div className="zwacop-step" key={index}>
                <div className="zwacop-step-number">{index + 1}</div>
                <div className="zwacop-step-icon">{step.icon}</div>
                <h4>{step.title}</h4>
                <p>{step.text}</p>
                {index < steps.length - 1 && <div className="zwacop-step-arrow"><FaArrowRight /></div>}
              </div>
            ))}
          </div>
        </div>

        <div className="zwacop-content">
          <div className="zwacop-visual">
            <div className="zwacop-image-wrapper">
              <img
                src="/images/application.png"
                alt="Application ZWACOP - Plateforme de mise en relation"
                className="zwacop-image"
                loading="lazy"
              />
              <div className="zwacop-image-overlay"></div>
              <div className="zwacop-visual-badge">
                <FaHandshake />
                <span>Mise en relation directe</span>
              </div>
            </div>
          </div>

          <div className="zwacop-info">
            <h3>Pourquoi utiliser ZWACOP ?</h3>
            <p>
              ZWACOP simplifie la recherche de services et crée des opportunités
              pour les prestataires. La plateforme connecte l'offre et la demande
              de manière fluide et accessible, contribuant au développement économique
              et à la valorisation des compétences locales.
            </p>
            <div className="zwacop-benefits">
              {benefits.map((benefit, index) => (
                <div className="zwacop-benefit" key={index}>
                  <div className="zwacop-benefit-icon">{benefit.icon}</div>
                  <span>{benefit.text}</span>
                </div>
              ))}
            </div>
            <a
              href="https://www.zwacop.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-lg"
            >
              Découvrir ZWACOP <FaExternalLinkAlt className="btn-icon" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Zwacop;